import React from 'react';
import { useSelector } from 'react-redux';
import { isNil } from 'ramda';
import * as Dumb from '../dumb';
const CollaboratorsList = () => {
  const {
    isOwner,
    collaborators,
    individualUpdateCollaboratorsPermissions
  } = useSelector(state => {
    var _state$unifiedPrivacy, _state$userPermission;
    return {
      collaborators: state.collaborators.value,
      isOwner: !!((_state$unifiedPrivacy = state.unifiedPrivacy.value) === null || _state$unifiedPrivacy === void 0 ? void 0 : _state$unifiedPrivacy.is_owner),
      individualUpdateCollaboratorsPermissions: (_state$userPermission = state.userPermissions.value) === null || _state$userPermission === void 0 ? void 0 : _state$userPermission.collaborator.individual.update
    };
  });
  if (isNil(individualUpdateCollaboratorsPermissions)) {
    return null;
  }
  return React.createElement(Dumb.CollaboratorList, {
    collaborators: collaborators,
    currentUserData: {
      isOwner,
      individualUpdateCollaboratorsPermissions
    }
  });
};
export default CollaboratorsList;